import * as Sentry from "@sentry/react";
import { useMutation } from "@tanstack/react-query";
import { z } from "zod";

import { APIResponse } from "../../api/common/response";
import { post } from "../../api/common/rooFetch";
import { queryClient } from "../../api/reactQueryClient";
import { CACHE } from "../../api/utility/constants";

const setCalendlyScheduledAtSchema = z.object({
  success: z.boolean(),
});

export type SetCalendlyScheduledAtResponse = z.infer<typeof setCalendlyScheduledAtSchema>;
export type SetCalendlyScheduledAtParams = {
  vetId: number;
  scheduledAt: string;
};

export const setCalendlyScheduledAt = async (params: SetCalendlyScheduledAtParams) => {
  const { vetId, scheduledAt } = params;

  const response = await post<{ scheduledAt: string }, APIResponse<SetCalendlyScheduledAtResponse>>(
    `api/vet/${vetId}/calendlyScheduledAt`,
    { scheduledAt },
    true
  );

  const parsedResponse = setCalendlyScheduledAtSchema.safeParse(response.data);
  if (!parsedResponse.success) {
    Sentry.captureException(parsedResponse.error);
    throw new Error("Invalid response format for setting Calendly scheduled at.");
  }
  return parsedResponse.data;
};

export const useSetCalendlyScheduledAt = () => {
  return useMutation((params: SetCalendlyScheduledAtParams) => setCalendlyScheduledAt(params), {
    onSuccess: () => queryClient.invalidateQueries({ queryKey: [CACHE.GET_USER_INFO] }),
  });
};
